export default __webpack_public_path__ + "static/media/Cross.95d8aecf.svg";